import React from 'react';
import PropTypes from 'prop-types';
import { ArrowRight } from 'lucide-react';
import Hyperlink from '../Hyperlink';
import { CountBadge } from '../Badge';
import './ActionList.css';

/**
 * ActionList — full-width rows between hairlines, each a DS Hyperlink
 * (large) with a leading icon, the label, an optional count and a trailing
 * arrow: the "Mitt konto" hub, a help centre's topics, a drawer's sections.
 */
const ActionList = ({ items, dividers = true, className = '', ...rest }) => (
  <ul className={['ds-action-list', dividers && 'ds-action-list--dividers', className].filter(Boolean).join(' ')} {...rest}>
    {items.map(({ id, icon, label, count, href, onClick }) => (
      <li key={id ?? label} className="ds-action-list__row">
        <Hyperlink
          variant="large"
          href={href || '#'}
          iconLeft={icon}
          iconRight={<ArrowRight size={20} />}
          className="ds-action-list__link"
          onClick={onClick}
        >
          {label}
          {count != null && <CountBadge value={count} className="ds-action-list__count" />}
        </Hyperlink>
      </li>
    ))}
  </ul>
);

ActionList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
    icon: PropTypes.node,
    label: PropTypes.node.isRequired,
    /** A count beside the label (CountBadge; hidden at 0) */
    count: PropTypes.number,
    href: PropTypes.string,
    onClick: PropTypes.func,
  })).isRequired,
  /** Hairlines above and between the rows */
  dividers: PropTypes.bool,
  className: PropTypes.string,
};

export default ActionList;
